import { Helmet } from 'react-helmet-async';
import '../App.css';
import { Header, Footer, PricingSection, FinalCta, useRevealObserver } from '../sections';

function PricingPage(): JSX.Element {
  useRevealObserver();

  return (
    <div className="splash-root">
      <Helmet defer={false}>
        <title>Game Localization Pricing — Flat $0.10 per Word</title>
        <meta name="description" content="One price, everything included. $0.10/word, 14-day turnaround, no setup fees, no per-seat licensing, no project minimums." />
        <link rel="canonical" href="https://useloten.com/pricing" />
        <meta property="og:title" content="Game Localization Pricing — Flat $0.10 per Word" />
        <meta property="og:description" content="One price, everything included. $0.10/word, 14-day turnaround, no setup fees, no per-seat licensing, no project minimums." />
        <meta property="og:url" content="https://useloten.com/pricing" />
        <meta name="twitter:title" content="Game Localization Pricing — Flat $0.10 per Word" />
        <meta name="twitter:description" content="One price, everything included. $0.10/word, 14-day turnaround, no setup fees, no per-seat licensing, no project minimums." />
      </Helmet>
      <a className="skip-link" href="#main-content">Skip to main content</a>

      <Header />

      <main id="main-content">
        <PricingSection
          heading="Game localization pricing, without the spreadsheet"
          subtitle="No tiers. No hidden fees. No per-seat licensing. Quote the cost of your next patch drop in your head."
        />
        <FinalCta />
      </main>

      <Footer />
    </div>
  );
}

export default PricingPage;
